<template>
    <div :class="'proposal-header ' +mode">
        <div v-if="application">
            <h1 class="application-title"><a :href="'/aanvraag/'+applicationId">{{ application.description }}</a></h1>
            <div class="proposal-info">
                <div class="row">
                    <div class="col">
                        <table>
                            <tr>
                                <td><strong>{{ trans('proposal.header_client') }}:</strong></td>
                                <td><strong>{{ application.company }}</strong></td>
                            </tr>
<!--                            <tr>-->
<!--                                <td>{{ trans('proposal.header_contact') }}:</td>-->
<!--                                <td>{{ application.contact.name }}</td>-->
<!--                            </tr>-->
                            <tr>
                                <td>{{ trans('proposal.header_email') }}:</td>
                                <td><a :href="'mailto:'+application.contact.email" style="color: #000;">{{ application.contact.email }}</a></td>
                            </tr>
                        </table>
                    </div>
                    <div class="col">
                        <table>
                            <tr>
                                <td>Booker:</td>
                                <td>{{ application.booker.name }}</td>
                            </tr>
                            <tr>
                                <td>{{ trans('proposal.header_email') }}: </td>
                                <td><a :href="'mailto:'+application.booker.email" style="color: #000;">{{ application.booker.email }}</a></td>
                            </tr>
                            <tr>
                                <td>{{ trans('proposal.header_phone') }}:</td>
                                <td>+31 20 420 38 21</td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>

            <div class="proposal-menu" v-if="mode !== 'finish'">
                <div class="wrapper">
                    <div class="proposal-list">
                        <div v-if="currentProposal" class="current-proposal-item">
                            <span class="proposal-row"  @click="toggleMenu()">
                                <span class="proposal-date" v-if="windowWidth > 400">{{formatDate(currentProposal.created)}}</span> <strong>{{currentProposal.description}} </strong>
                                <span class="hearts"  v-if="currentProposal.hearts">| <span class="noof-hearts">{{ currentProposal.hearts }}</span><i class="icon-heart"></i></span>
                            </span>
                            <div class="proposal-btns">
                                <div class="proposal-open-close" :class="allOpen ? 'open' : 'closed'" v-if="mode !== 'start'" @click="toggleMenu()"></div>
                                <div v-if="windowWidth > 400 && mode !== 'start'" class="proposal-finish">
                                    <a :href="'/aanvraag/'+applicationId+'/verstuur'" class="btn btn-orange">Klaar met selecteren</a>
                                </div>
                            </div>
                        </div>
                        <div v-if="allOpen || mode === 'start'">
                            <a v-for="(role, id) in application.roles" :key="id" :href="'/aanvraag/'+applicationId+'/'+role.uuid"  class="proposal-row" v-show="showRow(id)" v-if="proposalId !== id && role.description.indexOf('Model handmatig') === -1">
                                <span><span class="proposal-date"  v-if="windowWidth> 400">{{formatDate(role.created)}}</span> <strong>{{role.description}}</strong><span class="hearts" v-if="role.hearts">| <span class="noof-hearts">{{ role.hearts }}</span><i class="icon-heart"></i></span> </span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div  v-if="windowWidth < 401 && mode !== 'start'" class="proposal-finish-mobile">
                <a :href="'/aanvraag/'+applicationId+'/verstuur'" class="btn btn-orange">Klaar met selecteren</a>
            </div>

        </div>
    </div>
</template>
<script type='text/babel'>
    import {mapState} from 'vuex'


    export default {
        props: {
            mode: {default: 'default'},
            proposalId: {default: null},
        },
        data: function () {
            return {
                openRows: [],
                allOpen: false
            }
        },
        mounted(){
        },

        computed: {
            ...mapState(['application']),
            ...mapState(['favoritesIds']),
            ...mapState(['showConfirmDeleteFavorite']),
            currentProposal(){
                return this.application.roles[this.proposalId]
            },
            applicationId(){
                return this.application.id
            }
        },
        watch: {
            proposals() {
                this.setPullDown()
            }
        },
        methods: {
            // hearts(id) {
            //     let hearts = _.filter(this.application.roles[id].models, { 'favorite': '1'});
            //     return hearts.length
            // },
            showRow() {
                return this.allOpen || this.mode === 'start'
            },
            toggleMenu() {
                this.allOpen = !this.allOpen
            },
            setPullDown() {
                if (this.proposalId) {
                    // alert(this.proposalId)
                    // _.each(this.proposals, function (proposal) {
                    //     this.openRows[index] = proposal['VRST::Voorstelnummer'] === this.proposalId
                    // }.bind(this))
                }
            }
        },
    };
</script>
